import React, { useEffect } from 'react';

const WaitlistCTA = () => {
  useEffect(() => {
    // Load Tally embed script
    const loadTallyScript = () => {
      if (typeof window.Tally !== 'undefined') {
        window.Tally.loadEmbeds();
      } else {
        const iframes = document.querySelectorAll('iframe[data-tally-src]:not([src])');
        iframes.forEach((iframe) => {
          iframe.src = iframe.dataset.tallySrc;
        });
      }
    };

    const existingScript = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
    
    if (existingScript) {
      loadTallyScript();
    } else {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.onload = loadTallyScript;
      script.onerror = loadTallyScript;
      document.body.appendChild(script);
    }

    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
      <div className="max-w-4xl mx-auto text-center">
        {/* Content */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
          Ready to Monetize Your Audience?
        </h2>
        <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto">
          Get monetized and be among the first creators to experience AI-powered product creation.
        </p>

        {/* Tally Form Embed */}
        <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-xl shadow-emerald-100/50 p-8 border border-emerald-100">
          <iframe
            data-tally-src="https://tally.so/embed/gDqgEO?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            width="100%"
            height="588"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Welcome to Crevix"
            className="rounded-xl"
          ></iframe>
          
          {/* Fallback link */}
          <p className="text-slate-400 text-sm mt-6">
            Form not loading?{' '}
            <a 
              href="https://tally.so/r/gDqgEO" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-emerald-600 hover:text-emerald-700 underline underline-offset-2 transition-colors"
            >
              Click here to fill out the form
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WaitlistCTA;
